import React from 'react'
import { TopicInaccessibleGuard, TopicIndexNotReadyGuard } from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'
import EmptyResultGuard from './EmptyResultGuard'

const PostSearchGuard: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <TopicIndexNotReadyGuard widgetId={widgetId}>
      <EmptyResultGuard widgetId={widgetId}>{children}</EmptyResultGuard>
    </TopicIndexNotReadyGuard>
  </TopicInaccessibleGuard>
)

export default PostSearchGuard
